import { render, staticRenderFns } from "./AnnotationButtons.vue?vue&type=template&id=0aa51478&scoped=true&"
import script from "./AnnotationButtons.vue?vue&type=script&lang=ts&"
export * from "./AnnotationButtons.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0aa51478",
  null
  
)

export default component.exports